<template>
  <div class="default-modal js-password-modal" @click="cancel()">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="default-modal__bg js-default-modal-close"></div>
    <div class="default-modal__content l-password" @click="stopEvent()">
      <div class="default-modal__header">
        <a class="default-modal__close js-default-modal-close" @click="cancel()"></a>
      </div>
      <div class="default-modal__body">
        <div class="l-headding is-blueline password-change-modal-label">パスワード変更</div>
        <p class="l-text u-mb20" style="color:black;">パスワードは10文字以上としてください。<br>大文字、小文字、数字、記号（#,$,@など）を含めてください。</p>
        <table class="table">
            <tbody>
              <tr>
                <th class="password-change-modal-label">現在のパスワード</th>
                <td>
                  <Password v-model.trim="$v.form.$model.currentPassword" name="currentPassword" />
                  <ValidationErrorMessage v-show="$v.form.currentPassword.$error" validation="required" />
                </td>
              </tr>
              <tr>
                <th class="password-change-modal-label">新しいパスワード</th>
                <td>
                  <Password v-model.trim="$v.form.$model.newPassword" name="newPassword" />
                  <ValidationErrorMessage v-show="$v.form.newPassword.$error && !$v.form.newPassword.required" validation="required" />
                  <ValidationErrorMessage v-show="$v.form.newPassword.$error && !$v.form.newPassword.checkPasswordStrength" validation="checkPasswordStrength" />
                </td>
              </tr>
              <tr>
                <th class="password-change-modal-label">新しいパスワード(確認)</th>
                <td>
                  <Password v-model.trim="$v.form.$model.confirmPassword" name="confirmPassword" />
                  <ValidationErrorMessage v-show="$v.form.confirmPassword.$error && !$v.form.confirmPassword.required" validation="required" />
                  <ValidationErrorMessage v-show="$v.form.confirmPassword.$error && !$v.form.confirmPassword.sameAsPassword" validation="sameAsPassword" />
                </td>
              </tr>
            </tbody>
          </table>
        <div class="default-modal__footer">
          <div class="btn-group">
            <div class="btn-basic-small is-inlne">
              <button class="js-default-modal-close" @click="cancel()" :disabled="isProcessing">キャンセル</button>
            </div>
            <div class="btn-basic-small is-inlne is-primary"><button @click="modifyPassword()" :disabled="isProcessing">保存</button></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import Password from '@/components/parts/form/Password.vue';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import { required, sameAs } from 'vuelidate/lib/validators';
import { checkPasswordStrength } from '@/plugins/custom-vuelidate.js';

export default {
  components: {
    Loading,
    Password,
    ValidationErrorMessage,
  },
  data() {
    return {
      isProcessing: false,
      form: {
        currentPassword: null,
        newPassword: null,
        confirmPassword: null,
      },
      errorMessage: '',
    }
  },
  validations: {
    form: {
      currentPassword: {
        required
      },
      newPassword: {
        required,
        checkPasswordStrength
      },
      confirmPassword: {
        required,
        sameAsPassword: sameAs('newPassword')
      },
    }
  },
  created: function () {
  },
  methods: {
    async modifyPassword() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/password/modify', {
        currentPassword: this.form.currentPassword,
        newPassword: this.form.newPassword,
        confirmPassword: this.form.confirmPassword,
      });
      if (res.status === 200) {
        this.$toast.info('パスワードを変更しました');
        this.$emit("cancel-password-modify");
        this.$router.go({path: this.$router.currentRoute.path, force: true});
      } else {
        this.errorMessage = res.data.message;
        this.$toast.error(this.errorMessage);
      }
      this.isProcessing = false;
    },
    cancel() {
      this.$emit("cancel-password-modify");
    },
    stopEvent() {
      event.stopPropagation();
    }
  }
}

</script>

<style>
.password-change-modal-label {
  color: black;
}

</style>
